import '../public/checkmotors-rastreio';
import Vue from 'vue';
// eslint-disable-next-line
import * as Sentry from '@sentry/vue';
// eslint-disable-next-line
import { BrowserTracing } from '@sentry/tracing';
import vueDebounce from 'vue-debounce';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import VueTheMask from 'vue-the-mask';
import ImageUploader from 'vue-image-upload-resize';
import VueMeta from 'vue-meta';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueSignaturePad from 'vue-signature-pad';
import InfiniteScroll from 'vue-infinite-scroll';
import money from 'v-money';
import LottieAnimation from 'lottie-web-vue';
import VueViewer from 'v-viewer';
import App from './App';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import api from './plugins/axios';
import dexieDB from './services/dexieService';
import { getToken } from './services/tokenService';

Sentry.init({
  Vue,
  dsn: 'https://0c87e0d35f5a1afd701efe3331ec5556@o4507307354161152.ingest.us.sentry.io/4510799935242240',
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', /^\//]
    })
  ],
  tracesSampleRate: 1.0,
  sendDefaultPii: true,
  environment: process.env.NODE_ENV || 'production',
  logErrors: true
});

function getOS() {
  const uA = navigator.userAgent || navigator.vendor || window.opera;
  if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) return 'iOS';
  if (/android/i.test(uA)) return 'Android';
  return null;
}

function isAndroid() {
  if (getOS() === 'Android') {
    return true;
  }
  const urlParams = new URLSearchParams(window.location.search);
  return !!(urlParams.get('t') && urlParams.get('t') === 'android');
}

async function startOneSignalLoginAttempts() {
  const maxAttempts = 3;
  let attempts = 0;

  const oneSignalInterval = setInterval(async () => {
    const user = store.getters['Auth/user'];

    if (user && user.phone) {
      try {
        await window.median.onesignal.login(user.phone);

        window.median.onesignal.info().then(() => {});

        clearInterval(oneSignalInterval);
      } catch (error) {
        attempts += 1;

        if (attempts >= maxAttempts) {
          clearInterval(oneSignalInterval);
        }
      }
    } else {
      attempts += 1;

      if (attempts >= maxAttempts) {
        clearInterval(oneSignalInterval);
      }
    }
  }, 5000);
}

async function medianOnesignalPushOpened(data) {
  if (data && data.service_order) {
    try {
      if (window.vueInstance) {
        setTimeout(() => {
          window.vueInstance.$emit('view', { id: data.service_order, shouldOpenChat: data.open_chat });
        }, 1500);
      }
    } catch (error) {
      console.error('Erro ao processar notificação:', error);
    }
  }
}

if (isAndroid()) {
  window.median_onesignal_push_opened = medianOnesignalPushOpened;
}

async function waitForMedianAndConfigureCamera() {
  const maxTries = 300;
  let tries = 0;

  const interval = setInterval(async () => {
    if (window.median) {
      if (window.median.camera) {
        try {
          const parameters = await dexieDB.getParameters();
          const captureMode = parameters.find(({ name }) => name === 'media_capture_mode')?.value ?? 'dynamic';

          if (captureMode === 'stable') {
            window.median.camera.setCaptureQuality('low');
          }

          window.median.camera.saveToGallery(false);
        } catch (err) {
          console.error(err);
        }
      }

      startOneSignalLoginAttempts();
      clearInterval(interval);
    }

    tries += 1;
    if (tries >= maxTries) {
      clearInterval(interval);
    }
  }, 100);
}

if (isAndroid()) {
  waitForMedianAndConfigureCamera();
}

getToken().then((token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
});

Vue.use(VueSignaturePad);

Vue.use(InfiniteScroll);

Vue.use(LottieAnimation);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD_QMCcAyZduPKWbRO8IMWj66bBUeRGjD8',
    libraries: 'places,geometry'
  }
});

Vue.use(ImageUploader);

Vue.use(vueDebounce, {
  defaultTime: '700ms'
});

Vue.use(VueTheMask);

Vue.use(money, { precision: 4 });

Vue.use(Toast, {
  transition: 'Vue-Toastification__fade',
  maxToasts: 20,
  newestOnTop: true
});

Vue.use(VueViewer);

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

Vue.prototype.$http = api;
Vue.config.productionTip = true;

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');

window.vueInstance = app;

store.dispatch('Auth/loadFingerprint');
